import SiteUtilities from './site-utilities';
var locationReady = false;
var geoLocation;
const $doc = jQuery(document);

const init = function () {
  if (localStorage.getItem('geoLocation')) {
    geoLocation = JSON.parse(localStorage.getItem('geoLocation'));
    jQuery(document).trigger('locationReady');
    locationReady = true;
  } else {
    SiteUtilities.loadMaxmindScript('//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js', function (err) {
      if (err) {
        // locationReady is set to ensure that onLocationReady else case is
        // not reached geoLocation is then set to defaultGeoLocation object
        // with the same structure as geoLocation so that references don't fail.
        locationReady = true;
        geoLocation = defaultGeoLocation;
        jQuery(document).trigger('locationError');
      } else {
        try {
          window.geoip2.city(location => {
            // Success Callback
            geoLocation = location;
            if (localStorage.gdpr_preference !== 'NOT_ACCEPTED') {
              localStorage.setItem('geoLocation', JSON.stringify(location));
            }
            jQuery(document).trigger('locationReady');
            locationReady = true;
          }, error => {
            // Error Callback
            locationReady = true;
            geoLocation = defaultGeoLocation;
            jQuery(document).trigger('locationError');
            SiteUtilities.log(
              'Maxmind error callback',
              'error',
              'locationUtilities.geoLocationInit',
              1,
              error
            );
          });
        } catch (exception) {
          locationReady = true;
          geoLocation = defaultGeoLocation;
          jQuery(document).trigger('locationError');
          if (typeof window.geoip2 === 'undefined') {
            SiteUtilities.log(
              'Maxmind call failed. geoip2 undefined',
              'warning',
              'locationUtilities.geoLocationInit',
              1,
              exception
            );
          } else {
            SiteUtilities.log(
              'Maxmind call failed' + exception,
              'warning',
              'locationUtilities.geoLocationInit',
              1,
              window.geoip2
            );
          }
        }
      }
    });
  }
};

const defaultGeoLocation = {
  city: {
    geoname_id: 0,
    names: {}
  },
  continent: {
    code: '',
    geoname_id: 0,
    names: {}
  },
  country: {
    iso_code: '',
    geoname_id: 0,
    names: {}
  },
  location: {
    accuracy_radius: 0,
    latitude: 0,
    longitude: 0,
    time_zone: ''
  },
  postal: {
    code: ''
  },
  registered_country: {
    iso_code: '',
    geoname_id: 0,
    names: {}
  },
  subdivisions: [
    {
      iso_code: '',
      geoname_id: 0,
      names: {}
    }
  ],
  traits: {
    autonomous_system_number: 0,
    autonomous_system_organization: '',
    isp: '',
    organization: '',
    ip_address: ''
  },
  represented_country: {
    names: {}
  }
};

/*
* onLocationReady will return the triggering element using callback
*
* Usage
* =====
* LocationUtilities.onLocationReady(function () {
*  var a = JSON.parse(localStorage.getItem('geoLocation'));
*  a.city.names.en (result: Chennai)
* });
* callback should accept two arguments as defined below
* 1. This argument will be an object which contains the raw
*    location data. This can either be the data from a Maxmind
*    response or, in case of any failures in retrieving location
*    data, this object will contain the defaultGeoLocation object,
*    which has a structure identical to the maxmind response, but
*    with empty values. This is essential to avoid reference errors
*    in other parts of our code.
* 2. This argument will contain the processed location data, which
*    is basically the raw data (populated if it's from maxmind or
*    empty in case of failures) combined with short-cut essential
*    location data made available as root-level properties in this
*    object for ease of access.
*

*/
const onLocationReady = function (callback) {
  if (locationReady === true) {
    callback(geoLocation, _fillDefaults(geoLocation));
  } else {
    const locationEventHandler = (otherEventName) => {
      $doc.off(otherEventName);
      callback(geoLocation, _fillDefaults(geoLocation));
    };
    $doc.one('locationReady', () => locationEventHandler('locationError'));
    $doc.one('locationError', () => locationEventHandler('locationReady'));
  }
};
const _fillDefaults = (location) => {
  var data = {};
  try {
    data['ipAddress'] = location.traits.ip_address || '';
    data['countryCode'] = location.country.iso_code || '';
    data['countryName'] = location.country.names.en || '';
    data['continent'] = location.continent.code || '';
    data['continentName'] = location.continent.names.en || '';
    data['cityName'] = location.city.names.en || '';
    data['regionName'] = location.subdivisions[0].names.en || '';
    data['zipCode'] = location.postal.code || '';
    data['latitude'] = location.location.latitude || '';
    data['longitude'] = location.location.longitude || '';
    data['timeZone'] = location.location.time_zone || '';
    data['source'] = 'maxmind';
  } catch (exception) {
    SiteUtilities.log(
      'Default location object retrieval failed.',
      'warning',
      'locationUtilities.defaultLocation',
      1,
      exception
    );
    data['ipAddress'] = '';
    data['countryCode'] = '';
    data['countryName'] = '';
    data['continent'] = '';
    data['continentName'] = '';
    data['cityName'] = '';
    data['regionName'] = '';
    data['zipCode'] = '';
    data['latitude'] = '';
    data['longitude'] = '';
    data['timeZone'] = '';
  }
  const updatedGeoLocation = Object.assign({}, location, data);
  localStorage.setItem('simpleGeoLocation', JSON.stringify(updatedGeoLocation));
  return updatedGeoLocation;
};

const getGeoLocation = () => {
  try {
    return JSON.parse(localStorage.getItem('simpleGeoLocation')) || _fillDefaults(defaultGeoLocation);
  } catch (e) {
    return _fillDefaults(defaultGeoLocation);
  }
};

export default { init, onLocationReady, getGeoLocation };
